import { render, staticRenderFns } from "./ConsignmentOrders.vue?vue&type=template&id=1c974477&scoped=true"
import script from "./ConsignmentOrders.vue?vue&type=script&lang=js"
export * from "./ConsignmentOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c974477",
  null
  
)

export default component.exports